(() => {
  const TIMEOUT = 15000;

  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-config]').textContent);
    const {fragrances, packs, routes, text} = data;
    const decoder = document.createElement('textarea');
    Object.keys(text).forEach(key => { decoder.innerHTML = text[key]; text[key] = decoder.value; });
    const slots = [...root.querySelectorAll('[data-slot]')];
    const whatsapp=root.querySelector('[data-whatsapp]');
    whatsapp.addEventListener('click',e=>{if(!complete()||busy)e.preventDefault();});
    const addButton = root.querySelector('[data-add]');
    const status = root.querySelector('[data-status]');
    const added = root.querySelector('[data-added]');
    const choices = Array(5).fill('');
    let size = 3;
    let busy = false;
    let cartTotal = 0;
    let attempt = null;
    const money = value => 'Rs.' + value.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    const find = id => fragrances.find(f => f.id === id);
    const bottle = f => f.ladies ? text.amber : text.black;
    const active = () => choices.slice(0, size).map(find);
    const complete = () => active().every(Boolean);
    const format = (template, values) => template.replace(/\{(\w+)\}/g, (m, k) => k in values ? values[k] : m);

    slots.forEach((slot, i) => {
      const select = slot.querySelector('select');
      fragrances.forEach(f => { const o = document.createElement('option'); o.value=f.id; o.textContent=f.name+' · '+money(f.price); select.append(o); });
      select.addEventListener('change', () => {choices[i]=select.value; changed();});
    });

    function label() {
      const counts = new Map();
      active().forEach(f => counts.set(f, (counts.get(f) || 0) + 1));
      return fragrances.filter(f => counts.has(f)).map(f => f.name + (counts.get(f) > 1 ? ' ×' + counts.get(f) : '')).join(', ');
    }

    function say(message, kind) {
      status.textContent = message || '';
      status.dataset.kind = kind || '';
      status.setAttribute('role', kind === 'error' ? 'alert' : 'status');
      status.hidden = !message;
    }

    function changed() {
      attempt = null;
      added.hidden = true;
      say('');
      update();
    }

    function update() {
      const selected = active().filter(Boolean);
      const subtotal = selected.reduce((sum,f)=>sum+f.price,0);
      slots.forEach((slot,i)=>{
        slot.hidden=i>=size;
        slot.querySelector('select').disabled=i>=size||busy;
        const f=find(choices[i]);
        const note=slot.querySelector('[data-note]');
        note.textContent=f ? [f.notes, bottle(f)].filter(Boolean).join(' · ') : '';
        note.hidden=!f;
      });
      root.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.size)===size)));
      root.querySelector('[data-count]').textContent=format(text.progress, {count: selected.length, size});
      root.querySelector('[data-price]').textContent=complete()?money(subtotal):text['from_' + size];
      root.querySelector('[data-subtotal]').textContent=selected.length?money(subtotal):'—';
      root.querySelector('[data-progress]').textContent=complete()?text.ready:format(text.add_remaining, {count:size-selected.length});
      const canOrder=complete()&&!busy;
      whatsapp.setAttribute('aria-disabled',String(!canOrder));
      whatsapp.tabIndex=canOrder?0:-1;
      if(canOrder){
        const message=[text.wa_message,format(text.wa_pack,{size}),...active().map((f,i)=>(i+1)+'. '+f.name+' · 10 ml · '+money(f.price)),format(text.wa_price,{price:money(subtotal)}),text.wa_delivery].join('\n');
        whatsapp.href='https://wa.me/923152866516?text='+encodeURIComponent(message);
      }else whatsapp.removeAttribute('href');
      addButton.disabled=busy||!complete();
      addButton.querySelector('[data-add-label]').textContent=busy?text.adding:text.add_price;
      addButton.setAttribute('aria-busy', String(busy));
    }

    function request(url, options) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), TIMEOUT);
      return fetch(url, {credentials: 'same-origin', ...options, signal: controller.signal}).finally(() => clearTimeout(timer));
    }

    async function getCart() {
      const response = await request(routes.cart + '.js', {headers: {Accept: 'application/json'}});
      if(!response.ok) throw new Error('cart ' + response.status);
      return response.json();
    }

    function quantityOf(cart, variantId) {
      return cart.items.filter(item => item.variant_id === variantId).reduce((sum, item) => sum + item.quantity, 0);
    }
    async function findVariant(value) {
      const handles = packs[size];
      const query = 'query($v:String!){' + handles.map((h, i) => 'p' + i + ':product(handle:' + JSON.stringify(h) + '){variantBySelectedOptions(selectedOptions:[{name:"Fragrances",value:$v}]){id availableForSale price{amount}}}').join(' ') + '}';
      const response = await request(routes.storefront, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({query, variables: {v: value}})});
      if(!response.ok) throw new Error('storefront ' + response.status);
      const json = await response.json();
      if(json.errors) throw new Error('storefront errors');
      const match = handles.map((h, i) => json.data['p' + i] && json.data['p' + i].variantBySelectedOptions).find(Boolean);
      return match ? {id: Number(match.id.split('/').pop()), available: match.availableForSale, price: Math.round(Number(match.price.amount))} : null;
    }

    function notifyTheme(cart, variantId) {
      import('@shopify/events').then(({CartLinesUpdateEvent}) => {
        const deferred = CartLinesUpdateEvent.createPromise();
        root.dispatchEvent(new CartLinesUpdateEvent({action: 'add', context: 'product', lines: [{merchandiseId: String(variantId), quantity: 1}], promise: deferred.promise}));
        deferred.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {items: cart.items, source: 'aadab-testers', itemCount: 1, didError: false}});
      }).catch(() => {});
    }

    async function add() {
      if(busy || !complete()) return;
      busy = true;
      added.hidden = true;
      say(text.adding, 'info');
      update();
      const value = label();
      const expected = active().reduce((sum, f) => sum + f.price, 0);
      let variant = null;
      try {
        variant = await findVariant(value);
        if(!variant || !variant.available) return say(text.error_unavailable, 'error');
        if(variant.price !== expected) return say(text.error_price, 'error');
        const before = await getCart();
        if(!attempt || attempt.id !== variant.id) attempt = {id: variant.id, before: quantityOf(before, variant.id)};
        else if(quantityOf(before, variant.id) > attempt.before) return done(before, variant, value);
        let failed = null;
        try {
          const response = await request(routes.cart_add + '.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: variant.id, quantity: 1}]})});
          if(!response.ok) failed = text.error_generic;
        } catch(error) {
          failed = text.error_network;
        }
        const cart = await getCart();
        if(quantityOf(cart, variant.id) > attempt.before) return done(cart, variant, value);
        say(failed === text.error_network ? text.error_network : text.error_generic, 'error');
      } catch(error) {
        say(text.error_network, 'error');
      } finally {
        busy = false;
        update();
      }
    }

    function clear() {
      choices.fill('');
      slots.forEach(slot => { slot.querySelector('select').value = ''; });
    }
    function done(cart, variant, value) {
      attempt = null;
      cartTotal = Math.round(cart.total_price / 100);
      clear();
      say('');
      added.querySelector('[data-added-text]').textContent = format(text.added_text, {pack: value, price: money(variant.price)});
      added.hidden = false;
      added.focus({preventScroll: false});
      notifyTheme(cart, variant.id);
    }

    root.querySelectorAll('[data-size]').forEach(b=>b.addEventListener('click',()=>{if(busy)return;size=Number(b.dataset.size);showPhoto(size===5?1:0);changed();}));
    addButton.addEventListener('click', add);
    root.querySelector('[data-another]').addEventListener('click', () => {
      clear();
      changed();
      slots[0].querySelector('select').focus();
    });
    const slides=root.querySelector('[data-slides]');
    const thumbs=[...root.querySelectorAll('[data-thumb]')];
    let photoIndex=0;
    function markPhoto(index) {
      photoIndex=index;
      thumbs.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));
      root.querySelector('[data-gallery-count]').textContent=(index+1)+' / '+thumbs.length;
    }
    function showPhoto(index) {
      const next=(index+thumbs.length)%thumbs.length;
      const slide=slides.querySelectorAll('[data-slide]')[next];
      slides.scrollTo({left:slide.offsetLeft-slides.offsetLeft,behavior:'instant'});
      markPhoto(next);
    }
    thumbs.forEach((button,i)=>button.addEventListener('click',()=>showPhoto(i)));
    root.querySelector('[data-prev]').addEventListener('click',()=>showPhoto(photoIndex-1));
    root.querySelector('[data-next]').addEventListener('click',()=>showPhoto(photoIndex+1));
    slides.addEventListener('scroll',()=>{
      const width=slides.clientWidth;
      if(width)markPhoto(Math.max(0,Math.min(thumbs.length-1,Math.round(slides.scrollLeft/width))));
    },{passive:true});
    slides.addEventListener('keydown',e=>{
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){
        e.preventDefault();showPhoto(photoIndex+(e.key==='ArrowRight'?1:-1));
      }
    });
    const guide=root.querySelector('[data-guide]');
    fragrances.forEach(f=>{
      const row=document.createElement('div');row.className='at-guide-row';
      const name=document.createElement('strong');name.textContent=f.name;
      const notes=document.createElement('span');notes.textContent=[f.notes,bottle(f)].filter(Boolean).join(' · ');
      const inspiration=document.createElement('span');inspiration.className='at-guide-inspiration';
      inspiration.textContent=f.inspired?format(text.inspired_by,{fragrance:f.inspired}):text.original;
      row.append(name,inspiration,notes);guide.append(row);
    });
    getCart().then(cart => { cartTotal = Math.round(cart.total_price / 100); update(); }).catch(() => {});
    update();
  }
  document.querySelectorAll('[data-aadab-testers]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-aadab-testers]').forEach(init));
})();


